export default [
    {
        path: "/contabilizar",
        name: "Contabilizar",
        component: () => import("../views/Contabilizar"),
        meta: { requiresAuth: true },
    }
]